module.exports = __webpack_public_path__ + "static/media/Raleway-Bold.88079335.ttf";